function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 10H11.875C11.5298 10 11.25 10.2798 11.25 10.625V15.625C11.25 15.9702 11.5298 16.25 11.875 16.25H14.375C15.0654 16.25 15.625 15.6904 15.625 15V11.25C15.625 10.5596 15.0654 10 14.375 10ZM14.375 15H12.5V11.25H14.375V15Z",
  fill: "#B00808"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 11.25V10H16.875C16.5298 10 16.25 10.2798 16.25 10.625V16.25H17.5V13.75H20V12.5H17.5V11.25H20Z",
  fill: "#B00808"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 18.125V1.87501C1.25 1.52981 1.5298 1.25001 1.875 1.25001H11.25V3.75001C11.25 4.44036 11.8096 5.00001 12.5 5.00001H15V6.87501H16.25V4.37501C16.251 4.20888 16.1857 4.04919 16.0687 3.93126L12.3187 0.18126C12.2008 0.0642678 12.0411 -0.000927527 11.875 9.97262e-06H1.875C0.839453 9.97262e-06 0 0.839502 0 1.87501V18.125C0 19.1606 0.839453 20 1.875 20H6.25V18.75H1.875C1.52984 18.75 1.25 18.4702 1.25 18.125Z",
  fill: "#B00808"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 10H6.875C6.5298 10 6.25 10.2798 6.25 10.625V16.25H7.5V14.375H9.375C10.0654 14.375 10.625 13.8154 10.625 13.125V11.25C10.625 10.5596 10.0654 10 9.375 10ZM9.375 13.125H7.5V11.25H9.375V13.125Z",
  fill: "#B00808"
});

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.2e3ed000.svg";
export { ForwardRef as ReactComponent };